import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDotLegalLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32.233,
	height: 10.875,
	viewBox: "0 0 32.233 10.875",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_34",
		"data-name": "Group 34",
		transform: "translate(-19.142 -29.434)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group_33",
			"data-name": "Group 33",
			transform: "translate(23.967 29.434)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_851",
					"data-name": "Path 851",
					d: "M85.314,29.434v7.951H83.8V29.434Z",
					transform: "translate(-83.8 -29.434)",
					fill: "#000000"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_852",
					"data-name": "Path 852",
					d: "M130.386,58.549h-4.362a1.641,1.641,0,0,0,.429,1.171,1.382,1.382,0,0,0,.988.376,1.435,1.435,0,0,0,.876-.258,1.143,1.143,0,0,0,.446-.7h1.6a2.562,2.562,0,0,1-.5,1.117,2.639,2.639,0,0,1-.994.774,3.4,3.4,0,0,1-2.9-.091,2.6,2.6,0,0,1-1.053-1.058,3.7,3.7,0,0,1,0-3.25,2.563,2.563,0,0,1,1.054-1.058,3.208,3.208,0,0,1,1.547-.365,3.138,3.138,0,0,1,1.542.365,2.576,2.576,0,0,1,1.021,1,2.917,2.917,0,0,1,.36,1.456A2.871,2.871,0,0,1,130.386,58.549Zm-1.853-1.773a1.455,1.455,0,0,0-1.015-.376,1.489,1.489,0,0,0-1.032.376,1.539,1.539,0,0,0-.462,1.107h2.89A1.336,1.336,0,0,0,128.533,56.776Z",
					transform: "translate(-121.501 -53.284)",
					fill: "#000000"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_853",
					"data-name": "Path 853",
					d: "M223.942,55.56a1.932,1.932,0,0,1,.763.956V55.281h1.5v5.974a3.305,3.305,0,0,1-.328,1.488,2.417,2.417,0,0,1-.978,1.037,3.1,3.1,0,0,1-1.574.376,3.322,3.322,0,0,1-2.084-.613,2.533,2.533,0,0,1-.967-1.665h1.494a1.231,1.231,0,0,0,.5.7,1.655,1.655,0,0,0,.951.253,1.487,1.487,0,0,0,1.074-.392,1.576,1.576,0,0,0,.408-1.187V59.987a1.96,1.96,0,0,1-.763.962,2.262,2.262,0,0,1-1.289.36,2.556,2.556,0,0,1-1.354-.365,2.466,2.466,0,0,1-.939-1.058,4.083,4.083,0,0,1,0-3.256,2.468,2.468,0,0,1,.939-1.058,2.558,2.558,0,0,1,1.354-.365A2.288,2.288,0,0,1,223.942,55.56Zm-1.956,1.429a1.788,1.788,0,0,0-.429,1.268,1.768,1.768,0,0,0,.429,1.262,1.628,1.628,0,0,0,2.272-.011,1.995,1.995,0,0,0,0-2.514,1.5,1.5,0,0,0-1.134-.467,1.482,1.482,0,0,0-1.139.462Z",
					transform: "translate(-209.857 -53.282)",
					fill: "#000000"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_854",
					"data-name": "Path 854",
					d: "M327.328,55.561a1.931,1.931,0,0,1,.763.956V55.282h1.5v5.952h-1.5V59.989a1.96,1.96,0,0,1-.763.962,2.262,2.262,0,0,1-1.29.359,2.556,2.556,0,0,1-1.354-.365,2.467,2.467,0,0,1-.939-1.058,4.084,4.084,0,0,1,0-3.256,2.468,2.468,0,0,1,.939-1.058,2.558,2.558,0,0,1,1.354-.365,2.288,2.288,0,0,1,1.29.355Zm-1.956,1.429a1.788,1.788,0,0,0-.429,1.268,1.768,1.768,0,0,0,.429,1.262,1.628,1.628,0,0,0,2.272-.011,1.995,1.995,0,0,0,0-2.514,1.5,1.5,0,0,0-1.134-.467,1.482,1.482,0,0,0-1.139.462Z",
					transform: "translate(-305.529 -53.283)",
					fill: "#000000"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_855",
					"data-name": "Path 855",
					d: "M432.348,29.434v7.951h-1.515V29.434Z",
					transform: "translate(-404.94 -29.434)",
					fill: "#000000"
				})
			]
		}), /* @__PURE__ */ _jsx("circle", {
			id: "Ellipse_4",
			"data-name": "Ellipse 4",
			cx: 1.178,
			cy: 1.178,
			r: 1.178,
			transform: "translate(19.142 37.145) rotate(-76.717)",
			fill: "#8bbee8"
		})]
	})
});
export default SvgDotLegalLogo;
